import { useEffect, useState } from 'react';
import { gateway } from './gateway';

/* Is the provider assistant on for this signed-in provider? (2026-10-25)
   The three provider nav lists (ProviderShell, MobileMenu, Header) show
   "Assistant" only when it is: off unless ASSISTANT_ENABLED and the
   practice is listed (server/assistant/access.js), so other therapists
   never see a dead entry. One context check per signed-in provider per
   page load, shared by all three lists and the dashboard's box (AskBox).
   Once the answer is in, a screen that mounts later starts with it, so the
   entry and the box don't blink in on every visit. */

let cached = { userId: null, promise: null, value: null };

export default function useAssistantAvailable(user) {
  const isProvider = user?.accountType === 'PROVIDER';
  const userId = isProvider ? String(user._id || '') : null;
  const [on, setOn] = useState(() => !!userId && cached.userId === userId && cached.value === true);
  useEffect(() => {
    if (!userId) { setOn(false); return undefined; }
    let alive = true;
    if (cached.userId !== userId || !cached.promise) {
      const entry = { userId, promise: null, value: null };
      entry.promise = gateway.context()
        .then((c) => !!(c && c.enabled && c.role === 'provider'))
        .catch(() => false)
        .then((v) => { entry.value = v; return v; });
      cached = entry;
    }
    cached.promise.then((v) => { if (alive) setOn(v); });
    return () => { alive = false; };
  }, [userId]);
  return on;
}
